import { UiCard } from '@/ui/UiCard'
import { UiSkeleton } from '@/ui/UiSkeleton'

interface GroupCardSkeletonProps {
  withMembersPreview?: boolean
}

export default function GroupCardSkeleton({
  withMembersPreview = true,
}: GroupCardSkeletonProps) {
  return (
    <UiCard>
      <div className='space-y-3 p-6'>
        <div className='flex flex-col gap-2'>
          <UiSkeleton className='h-3 w-20' />
          <div className='flex items-center gap-2'>
            <UiSkeleton className='h-4 w-60 max-w-full' />
            <UiSkeleton className='h-4 w-4' />
          </div>
        </div>

        <div className='grid grid-cols-2 gap-4'>
          <div className='space-y-2'>
            <UiSkeleton className='h-3 w-16' />
            <UiSkeleton className='h-4 w-10' />
          </div>
          <div className='space-y-2'>
            <UiSkeleton className='h-3 w-20' />
            <UiSkeleton className='h-4 w-16' />
          </div>
        </div>

        {withMembersPreview && (
          <div className='space-y-2'>
            <UiSkeleton className='h-3 w-28' />
            <div className='flex flex-wrap gap-2'>
              <UiSkeleton className='h-6 w-28 rounded-md' />
              <UiSkeleton className='h-6 w-28 rounded-md' />
              <UiSkeleton className='h-6 w-16 rounded-md' />
            </div>
          </div>
        )}
      </div>
    </UiCard>
  )
}
